import { useEffect } from "react";
import { Button, Modal, Form, message } from "antd";

export default function DeleteCustomer({
  selected,
  isVisible,
  setDeleteModal,
}: any) {
  const [form] = Form.useForm();

  useEffect(() => {}, [selected]);

  const onSubmit = async () => {
    message.error("Sorry, you can't delete role");
    setDeleteModal(false);
  };

  const hideModal = async () => {
    setDeleteModal(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Delete Role"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="deleteRole"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form id="deleteRole" form={form} onFinish={onSubmit}>
        <div>
          <p className="text-center font-bold">
            Are you sure you want to delete this role
            <span className="text-red-500 ml-1">{selected?.name}</span>
          </p>
        </div>
      </Form>
    </Modal>
  );
}
